(function(){
  function q(s,r){return (r||document).querySelector(s);}
  function qa(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));}
  function init(){
    var open=q('#st-native-filter-open'), close=q('#st-native-filter-close'),
        drawer=q('#st-native-filter-drawer'), overlay=q('#st-native-filter-overlay');
    if(!open||!drawer||!overlay)return;
    function show(){drawer.classList.add('is-open');overlay.classList.add('is-open');drawer.setAttribute('aria-hidden','false');open.setAttribute('aria-expanded','true');document.body.classList.add('st-native-filter-open');}
    function hide(){drawer.classList.remove('is-open');overlay.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');open.setAttribute('aria-expanded','false');document.body.classList.remove('st-native-filter-open');}
    open.addEventListener('click',show);
    if(close)close.addEventListener('click',hide);
    overlay.addEventListener('click',hide);
    document.addEventListener('keydown',function(e){if(e.key==='Escape')hide();});
    qa('.st-native-filter-heading',drawer).forEach(function(btn){
      btn.addEventListener('click',function(){
        var section=btn.closest('.st-native-filter-section');
        var collapsed=section.classList.toggle('is-collapsed');
        btn.setAttribute('aria-expanded',collapsed?'false':'true');
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();